module.exports = __webpack_public_path__ + "static/media/ambulance.d8debd66.svg";